<div class="with-3-levels box-content">
  <ul class="second-to-last-level">
    <ng-container *ngFor="let secondLevel of node?.children">
      <li *ngIf="secondLevel?.children?.length || secondLevel.url">
        <nav-label [node]="secondLevel" classContainer="label-second-to-last-level"></nav-label>

        <ul class="third-level">
          <ng-container *ngFor="let thirdLevel of secondLevel?.children">
            <li *ngIf="thirdLevel?.children?.length || thirdLevel.url">
              <nav-label [node]="thirdLevel" classContainer="label"></nav-label>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>

  <div class="box-image" style=" background-image: url('{{ getBaseURL(node.media) }}');"></div>
</div>
